<template>
 <div class="status-badge"  :class="[`--${variant}`]">
   <slot></slot>
 </div>
</template>
 
<script>    
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
 
    variant: {
      type: String,
      default: 'success',
      validator: function (value) {
        return ['success', 'warning', 'danger', 'primary', 'secondary'].includes(value)
      }
    }
  },
}
</script>
 
<style lang="scss">
.status-badge {
    display: inline-block;
    font-family: 'Inter';
    font-size: 12px;
    font-weight: 300;
    text-transform: uppercase;
    padding: 2px 8px;
    border-radius: 3px;
    min-height: 24px;
    text-align: center;
   
    // Variants
    &.--success {
      color: var(--success);
      border: 1px solid var(--success);
      background: rgba(#34D188, 0.15);
    }
 
    &.--warning {
      color: var(--warning);
      border: 1px solid var(--warning);
      background: rgba(#FFA953, 0.15);
    }
 
    &.--danger {
      color: var(--danger);
      border: 1px solid var(--danger);
      background: rgba(#FF4E66, 0.15);
    }
 
    &.--primary {
      color: var(--primary);
      border: 1px solid var(--primary);
      background: rgba(#1560F6, 0.15);
    }
 
    &.--secondary {
      color: var(--secondary);
      border: 1px solid var(--secondary);
      background: rgba(#787E95, 0.15);
    }
  }
</style>